/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "取消"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "您已获得访问客户数据的商业理由"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "出于安全合规目的，您的下载活动将被记录和跟踪"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "您要继续吗？"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "下载即表示您承认："
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
